import api from "@helpers/api";

import { STATUS } from "@constants/status.hrm";
import { URLS } from "@constants/urls";

import { TicketSettingsType } from "@type/tickets/ticket-settings";

const { TICKETS, COMMENTS } = URLS;
const { SUCCESS, FAILED } = STATUS;

const apiEndPoint = `${process.env.REACT_APP_E_TICKETING_SERVICE_BASE_URL}${process.env.REACT_APP_E_TICKETING_SERVICE_PORT}/${process.env.REACT_APP_E_TICKETING_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${TICKETS}`;

export const getTicket = (() => {
  return async (ticketId: string | undefined) => {
    return api
      .get(`${apiEndPoint}/${ticketId}`)
      .then((response) => response.data);
  };
})();

export const createTicket = (() => {
  return async (
    formData: TicketSettingsType,
    afterEffect: (param: any) => void,
  ) => {
    const {
      unit,
      category,
      subject,
      issueName,
      requestDetails,
      type,
      priority,
      document,
    } = formData;

    return api
      .post(apiEndPoint, {
        unit,
        category,
        subject,
        issueName,
        requestDetails,
        type,
        priority,
        document,
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const updateTicket = (() => {
  return async (
    ticketId: number,
    formData: TicketSettingsType,
    afterEffect: (param: any) => void,
  ) => {
    return api
      .put(`${apiEndPoint}/${ticketId}`, {
        ...formData,
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const addTicketComment = (() => {
  return async (
    ticketId: number,
    formData: TicketSettingsType,
    afterEffect: (param: any) => void,
  ) => {
    return api
      .post(`${apiEndPoint}/${ticketId}/${COMMENTS}`, {
        ...formData,
      })
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();
